import { store } from '../store';

/**
 * `translate` and `editableTranslate` will be deprecated in favor of the new translation system
 * Please use the `useTranslation` hook instead.
 *
 * `localTranslate` and `editableTranslateString` still in use but expect it to be move as well
 */

function translate(translation, lang, key, alt = null) {
  return translation[key] ? (translation[key][lang] || translation[key]['en']) : (alt || key);
}

function editableTranslate(translation, lang, key, alt = null) {
  const userState = store.getState().user;

  const isExternal = (process.env.REACT_APP_ENV !== 'local' && !userState.tenant.is_internal);
  const text = translate(translation, lang, key, alt);

  const hasBreakline = text && text.includes('\n');

  return <span className={!isExternal ? `editable-translation ${userState.debug_translation ? 'enabled' : ''}` : ''} data-key={key}>
    {
      !hasBreakline ? text : text.split('\n').map((t, i) => <span key={i}>
        {i > 0 && <br />}
        {t}
      </span>)
    }
  </span>;
}

function localTranslate(key, alt = null) {
  const cached = JSON.parse(localStorage.getItem('translation.cache') || '{}');
  const lang = localStorage.getItem('preferred_lang') || 'en';

  const sources = [cached.global || {}, cached.tooltips || {}, cached.dropdowns || {}];

  for (const dict of sources) {
    if (dict[key] && (dict[key][lang] || dict[key]['en'])) {
      return dict[key][lang] || dict[key]['en'];
    }
  }

  return alt || key;
}

function editableTranslateString(translation, lang, key, alt = null) {
  const userState = store.getState().user;

  if (process.env.REACT_APP_ENV !== 'local' && !userState.tenant.is_internal) {
    return translate(translation, lang, key, alt);
  }

  return `<span class='editable-translation ${userState.debug_translation ? "enabled" : ""}' data-key='${key}'>${translate(translation, lang, key, alt)}</span>`;
}

export { localTranslate, translate, editableTranslate, editableTranslateString };
